const reportMail = "devgabrielribeiro@gmail.com";
const contactLotus = "https://lts.app.br";
const currentTableFares = "https://github.com/gabriersdev/mobilidade/blob/main/public/docs/doc-aumento-metropolitano-2026.pdf";

const linesWithManualIntegration = [
  4660,
  4610,
  4620,
  4640,
  4645,
  4650,
  4651,
  4655,
  4660,
  4665,
  4670,
  4675,
  4676,
  4677,
  4680,
  4685,
  4687,
  
  4900,
  4920,
  4925,
  
  4970,
  4988,
  4991,
  4993,
  4997,
  4998,
  4999,
  
  4989,
  4990,
  4992,
];

const linesWithManualIntegrationWithSubwayBH = [
  4685,
  4687,
]

const navLinks = [
  {name: "Início", path: "./"},
  {name: "Linhas", path: "./lines"},
  {name: "Pesquisa", path: "./search", mobileOnly: true},
  {name: "Guia", path: "./guide"},
  {name: "Frotas", path: "./bus", newTagLimit: "2026-08-25T00:00:00"},
  {name: "Notícias", path: "./news"},
  {name: "Ao vivo", path: "./live", isLive: true},
  {name: "Cidade de Sabará", path: "./sabara", mobileOnly: true, showOnlyFooter: true},
  {name: "Companhias", path: "./company", mobileOnly: true, showOnlyFooter: true},
];

const footerLinks = [
  {name: "Desenvolvimento", path: "/development#topo"},
  {name: "Termos de serviços", path: "/terms-of-service#topo"},
  {name: "Privacidade", path: "/privacy#topo"},
  {name: "Manifesto", path: "/manifest#topo"},
]

const dateConfigs = {
  locale: "America/Sao_Paulo",
  lang: "pt-BR",
  UTC: -3,
  UTC2: -180,
  timeFormat: "HH:mm",
  timeFormatFriendly: "HH[h]mm"
}

const numberConfigs = {
  lang: "pt-BR",
  fixed: 2
}

const quickSearchLinks = [
  "Rodoviária de Sabará",
  "Terminal São Gabriel",
  "Estação José Cândido da Silveira",
  "Estação São Gabriel",
  "Rua dos Caetés",
  "Andradas",
  "Rodoviária de Belo Horizonte",
]

const labelMap = {
  "lines": "Linhas",
  "search": "Pesquisa",
  "terms-of-service": "Termos de Serviço",
  "privacy": "Privacidade",
  "company": "Companhia",
  "development": "Desenvolvimento",
  "news": "Notícias",
  "history": "Histórico",
  "guide": "Guia",
  "live": "Ao vivo",
  "sabara": "Sabará",
  "manifest": "Manifesto",
  "re-valid-session": "Validação de nova sessão",
  "busao-0800": "Busão 0800",
  "bus": "Frotas",
}

const navLinksPageLine = [
  {id: "id", label: "Informações", className: "d-none d-sm-inline-block"},
  {id: "partidas", label: "Horários"},
  {id: "paradas", label: "Paradas"},
  {id: "pontos-de-recarga", label: "Recarga"},
  {id: "mapa", label: "Mapa", hideIfNotFound: true},
  {id: "resume", label: "Sobre", className: "d-none"},
];

const elementIdsPageLine = [
  "id",
  "partidas",
  "paradas",
  "pontos-de-recarga",
  "mapa",
  "resume"
];

const navLinksPageBus = [
  {id: "id", label: "Identificação", className: "d-none d-sm-inline-block"},
  // {id: "linhas-operadas", label: "Linhas"},
  {id: "especificacoes-tecnicas", label: "Técnica"},
  {id: "conforto-e-acessibilidade", label: "Conforto"},
  // {id: "identidade", label: "Identidade"},
  {id: "historico", label: "Histórico"},
];

const elementIdsPageBus = [
  "id",
  "linhas-operadas",
  "especificacoes-tecnicas",
  "conforto-e-acessibilidade",
  "identidade",
  "historico"
];

const vehiclePropertiesImagesSRC = {
  "marcopolo": "/images/bus/bodywork-manufacturers/marcopolo.png",
  "neobus": "/images/bus/bodywork-manufacturers/neobus.png",
  "mercedes-benz": "/images/bus/chassis-manufacters/mercedes-benz.png",
}


export {
  reportMail,
  contactLotus,
  currentTableFares,
  linesWithManualIntegration,
  navLinks,
  footerLinks,
  dateConfigs,
  numberConfigs,
  quickSearchLinks,
  labelMap,
  navLinksPageLine,
  elementIdsPageLine,
  navLinksPageBus,
  elementIdsPageBus,
  linesWithManualIntegrationWithSubwayBH,
  
  vehiclePropertiesImagesSRC,
}
